import { Suspense, useRef, useState } from 'react'
import { Button } from '~/shared/ui'
import { DocumentReviewLayout } from '~/widgets/document-review-layout'
import { DataExtraction, type DataExtractionRef } from './data-extraction/data-extraction'
import { LoadingSkeleton } from './data-extraction/loading-skeleton'
import type { DataExtractionMode } from './types'

export function DocumentDataExtractionPage() {
  return <DataExtractionContent />
}

function DataExtractionContent() {
  const [mode, setMode] = useState<DataExtractionMode>('view')
  const dataExtractionRef = useRef<DataExtractionRef>(null)

  const onModifyFieldsClick = () => {
    setMode('edit')
  }

  const handleApplyChanges = () => {
    dataExtractionRef.current?.applyChanges()
    setMode('view')
  }

  const handleCancelChanges = () => {
    dataExtractionRef.current?.cancelChanges()
    setMode('view')
  }

  return (
    <DocumentReviewLayout
      step="Data Extraction"
      loader={<LoadingSkeleton />}
      actions={
        mode === 'view' ? (
          <Button
            size="small"
            onClick={onModifyFieldsClick}
            materialIcon="edit_document"
          >
            Modify fields
          </Button>
        ) : (
          <div className="flex gap-2">
            <Button
              size="small"
              onClick={handleCancelChanges}
              unelevated
              tonal
            >
              Cancel fields changes
            </Button>
            <Button
              size="small"
              onClick={handleApplyChanges}
              raised
            >
              Close & apply fields
            </Button>
          </div>
        )
      }
    >
      <Suspense fallback={<LoadingSkeleton />}>
        <DataExtraction
          ref={dataExtractionRef}
          mode={mode}
        />
      </Suspense>
    </DocumentReviewLayout>
  )
}
